module.exports = __webpack_public_path__ + "static/media/airplane.5402f89a.png";